// extracted by mini-css-extract-plugin
export var deleteModal = "_ia-0";